import type { FC } from 'react';

import { useGetQuestionnaireTemplateVersionById } from '@/hooks/queries/questionnaire-template-version/useGetQuestionnaireTemplateVersionById';

type Props = {
  questionnaireTemplateVersionId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ questionnaireTemplateVersionId }) => {
  if (!questionnaireTemplateVersionId) {
    throw new Error('Missing questionnaireTemplateVersionId param');
  }

  const { data } = useGetQuestionnaireTemplateVersionById(
    questionnaireTemplateVersionId
  );

  return <>{data?.questionnaire_template_version?.Version || ''}</>;
};

export default Breadcrumb;
